import * as types from "./actionTypes";

const initialState = {
  loading: false,
  streetLight: [],
  streetLightDetail: null,
  streetLightHistory: []
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_STORE_USER:
      return initialState;

    case types.STREET_LIGHT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.STREET_LIGHT_SUCCESS:
      // console.log('check', action.payload)
      return {
        ...state,
        loading: false,
        streetLight: action.payload,
      };
    case types.STREET_LIGHT_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.STREET_LIGHT_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.STREET_LIGHT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        streetLightDetail: action.payload,
      };
    case types.STREET_LIGHT_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        streetLightDetail: null,
      };

      case types.STREET_LIGHT_HISTORY_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case types.STREET_LIGHT_HISTORY_SUCCESS:
        return {
          ...state,
          loading: false,
          streetLightHistory: action.payload,
        };
      case types.STREET_LIGHT_HISTORY_ERROR:
        return {
          ...state,
          loading: false,
          streetLightHistory: [],
        };
    case types.UPDATE_STREET_LIGHT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.UPDATE_STREET_LIGHT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.UPDATE_STREET_LIGHT_ERROR:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default userReducer;
